if (!customElements.get('fws-home-gallery')) {
  customElements.define('fws-home-gallery', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-fh-image]');
        if (!button || !this.contains(button)) return;
        const image = this.querySelector('.fh-gallery-main');
        if (!image) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = button.dataset.fhImage;
        image.alt = button.dataset.fhAlt;
        this.querySelectorAll('[data-fh-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }, {signal: this.events.signal});
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
if (!customElements.get('fws-finish-gallery')) {
  customElements.define('fws-finish-gallery', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      clearTimeout(this.resetTimer);
      this.events = new AbortController();
      const track = this.querySelector('.fh-finish-track');
      const button = this.querySelector('.fh-finish-next');
      const count = this.querySelector('.fh-finish-count');
      if (!track || !button) return;
      track.querySelectorAll('[data-fh-clone]').forEach(slide => slide.remove());
      const slides = Array.from(track.children);
      const total = slides.length;
      if (!total) { button.hidden = true; return; }
      slides.slice(0, 2).forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.dataset.fhClone = '';
        clone.setAttribute('aria-hidden', 'true');
        track.append(clone);
      });
      let index = 0;
      let moving = false;
      const render = animate => {
        const step = slides[0].getBoundingClientRect().width + 6;
        track.style.transition = animate ? 'transform 420ms cubic-bezier(.22,.61,.36,1)' : 'none';
        track.style.transform = 'translateX(' + (-index * step) + 'px)';
        if (count) count.textContent = (index % total + 1) + ' / ' + total;
        slides.forEach((slide, position) => slide.setAttribute('aria-hidden', String(position !== index % total && position !== (index + 1) % total)));
      };
      const settle = () => {
        clearTimeout(this.resetTimer);
        if (index >= total) { index = 0; render(false); }
        moving = false;
      };
      render(false);
      button.hidden = total < 3;
      button.addEventListener('click', () => {
        if (moving || total < 3) return;
        moving = true;
        index += 1;
        const animate = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        render(animate);
        if (animate) this.resetTimer = setTimeout(settle, 480);
        else settle();
      }, {signal: this.events.signal});
      track.addEventListener('transitionend', event => {
        if (event.target === track && event.propertyName === 'transform') settle();
      }, {signal: this.events.signal});
      this.resizeObserver = new ResizeObserver(() => { settle(); render(false); });
      this.resizeObserver.observe(this);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      clearTimeout(this.resetTimer);
    }
  });
}
